import { Minus, Plus, ShoppingBag, Trash2, X } from 'lucide-react';
import { useState } from 'react';
import { useCart } from '../../hooks/useCart';
import { cartApi } from '../../services/api/cartApi';
import { formatCurrency } from '../../utils/formatters';

export default function CartDrawer() {
  const { items, totalAmount, isCartOpen, closeCart, incrementItem, decrementItem, removeItem, clearCart } =
    useCart();
  const [isCheckingOut, setIsCheckingOut] = useState(false);
  const [checkoutError, setCheckoutError] = useState(null);

  if (!isCartOpen) {
    return null;
  }

  async function handleCheckout() {
    setIsCheckingOut(true);
    setCheckoutError(null);
    try {
      const cart = await cartApi.createCheckout(items);
      window.location.href = cart.checkoutUrl;
    } catch (error) {
      setCheckoutError(error.message);
      setIsCheckingOut(false);
    }
  }

  function handleClose() {
    setCheckoutError(null);
    closeCart();
  }

  return (
    <div className="modal-root" role="dialog" aria-modal="true" aria-label="Carrito de compra">
      <button className="modal-backdrop" onClick={handleClose} aria-label="Cerrar carrito" />
      <aside className="cart-drawer">
        <div className="cart-drawer__header">
          <div>
            <p className="eyebrow">Tu selección</p>
            <h2>Carrito</h2>
          </div>
          <button className="icon-button" onClick={handleClose} aria-label="Cerrar carrito">
            <X size={18} />
          </button>
        </div>

        {items.length === 0 ? (
          <div className="cart-drawer__empty">
            <ShoppingBag size={32} />
            <h2>Tu carrito está vacío</h2>
            <p>Explora el catálogo y añade productos para verlos aquí.</p>
          </div>
        ) : (
          <>
            <div className="cart-drawer__items">
              {items.map((item) => (
                <article className="cart-item" key={item.productId}>
                  <div className="cart-item__media">
                    <img src={item.image} alt={item.name} />
                  </div>
                  <div className="cart-item__body">
                    <div className="cart-item__heading">
                      <h3>{item.name}</h3>
                      <button
                        className="icon-button"
                        type="button"
                        onClick={() => removeItem(item.productId)}
                        aria-label={`Quitar ${item.name} del carrito`}
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                    <span className="cart-item__weight">{item.weight}</span>
                    <div className="cart-item__footer">
                      <div className="qty-stepper">
                        <button
                          type="button"
                          onClick={() => decrementItem(item.productId)}
                          aria-label={`Quitar una unidad de ${item.name}`}
                        >
                          <Minus size={14} />
                        </button>
                        <span>{item.quantity}</span>
                        <button
                          type="button"
                          onClick={() => incrementItem(item.productId)}
                          aria-label={`Añadir una unidad de ${item.name}`}
                        >
                          <Plus size={14} />
                        </button>
                      </div>
                      <strong>{formatCurrency(item.price * item.quantity)}</strong>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            <div className="cart-drawer__footer">
              <div className="cart-drawer__subtotal">
                <span>Subtotal</span>
                <strong>{formatCurrency(totalAmount)}</strong>
              </div>
              {checkoutError && <p className="muted-copy">{checkoutError}</p>}
              <button className="button button--primary" type="button" onClick={handleCheckout} disabled={isCheckingOut}>
                {isCheckingOut ? 'Preparando pago...' : 'Pagar en Shopify'}
              </button>
              <button className="text-link" type="button" onClick={clearCart}>
                Vaciar carrito
              </button>
            </div>
          </>
        )}
      </aside>
    </div>
  );
}
